import Button from '@ingka/button';
import Text from '@ingka/text';
import type { FallbackProps } from 'react-error-boundary';
import { useTranslation } from 'react-i18next';
import styles from './ErrorBoundryPage.module.scss';

export const ErrorFallback: React.ComponentType<FallbackProps> = (props: FallbackProps) => {
  const { t } = useTranslation();
  return (
    <div className={styles['container']}>
      <Text tagName="h2" headingSize="s" className={styles['text']}>
        {t('general-something-went-wrong')}
      </Text>
      <Button
        className={styles['tryAgainButton']}
        onClick={() => {
          myErrorHandler(props.error);
        }}
      >
        {t('general-reload')}
      </Button>
    </div>
  );
};

const myErrorHandler = (error: Error) => {
  // If we want anything else to happen than reloading the page, we can do it here
  window.location.reload();
};
